import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  stage: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.number().required(),
    })
    .required('Etapa é obrigatória'),
  process: Yup.object()
    .shape({
      label: Yup.string().required(),
      value: Yup.number().required(),
    })
    .required('Processo é obrigatório'),
  serviceType: Yup.object().shape({
    label: Yup.string().required(),
    value: Yup.number().required(),
  }),
  message: Yup.string().required('Mensagem é obrigatória'),
});
